<template>
    <div class="orderlist_page">
        <div class="orderlist-modal" v-if="modalStatus" @touchmove.prevent>
            <div class="commentSheet" :class="{'open':sheetStatus}" >
                <div class="head-title">
                    <img class="close" src="../assets/images/popup_close@3x.png" @click="closeSheet">
                    <h2>订单评价</h2>
                </div>
                <ul class="content">
                    <li class="complete">
                        <div class="title">
                            <img src="../assets/images/evaluation_data_icon@3x.png">
                            <span>您是否得到了您想要的数据?</span>
                        </div>
                        <ul>
                            <li class="get" :class="{'active':comment.data_recovered == '1'}">
                                <div class="img"></div>
                                <span>得到了</span>
                            </li>
                            <li class="none" :class="{'active':comment.data_recovered == '2'}">
                                <div class="img"></div>
                                <span>没得到</span>
                            </li>
                            <li class="notget" :class="{'active':comment.data_recovered == '4'}">
                                <div class="img"></div>
                                <span>不清楚</span>
                            </li>
                        </ul>
                    </li>
                    <li class="satisfied">
                        <div class="title">
                            <img src="../assets/images/evaluation_eng_icon@3x.png">
                            <div class="text">
                                <p>{{comment.eng_no}}号工程师</p>
                                <span>请给为您提供服务的工程师打分</span>
                            </div>
                        </div>
                        <ul>
                            <li class="great" :class="{'active':comment.eng_score == 90}">
                                <div class="img"></div>
                                <span>超赞</span>
                            </li>
                            <li class="soso" :class="{'active':comment.eng_score == 60}">
                                <div class="img"></div>
                                <span>一般</span>
                            </li>
                            <li class="bad" :class="{'active':comment.eng_score == 30}">
                                <div class="img"></div>
                                <span>非常差</span>
                            </li>
                        </ul>
                    </li>
                    <li class="suggestion">
                        <p>{{comment.content}}</p>
                    </li>
                </ul>

                <div class="evaluation-time">
                    评价时间：2019.08.29 13:02
                </div>
            </div>
        </div>

        <div class="main-wrapper">
            <mt-header fixed title="订单列表" style="background:#ffffff;color:#262626;">
                <mt-button icon="back" slot="left" @click="goBack" v-if="path"></mt-button>
                <mt-button slot="right">
                    <img src="../assets/images/global_message@3x.png" style="width: 20px;height:20px" @click="goMessages">
                </mt-button>
            </mt-header>

            <div class="scroll-wrapper">
                <div class="scroll-content">
                    <div class="no-data" v-if="!loginstatus">
                        <img src="../assets/images/orderlist_data_none@3x.png">
                        <p>您尚未登录果师兄<br/>登录后可以查看订单相关信息</p>
                        <div class="goBack" @click="goLogin('立即登录')">立即登录</div>
                    </div>

                    <div class="order_wrapper" v-if="loginstatus">
                        <Loadmore  :top-method="loadTop"  ref="loadmore" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded"  bottomPullText='加载中' :auto-fill='false'>
                            <div class="no-data" v-if="norder">
                                <img src="../assets/images/orderlist_data_none@3x.png">
                                <p>没有订单数据<br/>没找到订单？您可以切换登录方式</p>
                                <div class="goBack" @click="goLogin('切换登录方式')">切换登录方式</div>
                            </div>
                            <ul class="order_list">
                                <li v-for="(item,index) in orders" :key="item.detail[0].orderno" class="order" @click.prevent="goOrderDetail(item.status,item.detail[0].orderno,item.detail[0].allow_chat)">
                                    <div class="slider-content" @touchstart='touchStart($event,index,item)'
                                            @touchmove='touchMove($event,index)'
                                            @touchend='touchEnd($event,index)'
                                            :style="deleteSlider[index]">
                                        <div class="order-detail">
                                            <img :src="item.detail[0].g_thumb" class="order_icon"/>
                                            <div class="order-info">
                                                <p class="g_description"> {{item.detail[0].g_description}} </p>
                                                <p class="gm_name"> {{item.detail[0].gm_name}} </p>
                                                <p class="g_orderno"> {{item.detail[0].orderno}} </p>
                                            </div>
                                            <div class="price">¥{{item.total}}</div>
                                        </div>
                                        <div class="order-status_wrapper">
                                            <div class="message">
                                                <span class="pay_status pay " v-if="item.status == 3 && item.refund_status == -1">支付完成</span>
                                                <span class="pay_status nopay"  v-if="item.status == 2">未支付</span>
                                                <span class="pay_status " v-if="item.status == 1">订单已取消</span>
                                                <span class="pay_status " v-if="item.refund_status != -1">{{item.refund_text}}</span>
                                                <div class="service_info" v-if="item.service && item.service.service_no">
                                                    工单：<span :status="item.service.status" class="status" >{{item.service.status | serviceStatus}}</span>
                                                </div>
                                            </div>

                                            <div class="need_pay" v-if="item.status == 2">
                                                <span class="cancel" @click.stop="cancelOrder(item.detail[0].orderno)">取消订单</span>
                                                <button class="payNow" @click.stop="gopay(item.orderno)">立即支付</button>
                                            </div>
                                            <div class="need_pay" v-if="item.detail[0].allow_chat && item.status == 3 && item.service.eng_no && !(item.service.status == 6 || item.service.status == 7)">
                                                <button class="contact-eng">联系工程师</button>
                                            </div>
                                            
                                            <div class="need_pay" @click.stop="goEvaluation(item.service)" 
                                            v-if="(item.service.status == 6 || item.service.status == 7) && item.last_comment == 0">
                                                <button class="contact-eng">评价</button>
                                            </div>

                                            <div class="need_pay" @click.stop="getCommentDetail(item.last_comment)" 
                                            v-if="item.last_comment != 0">
                                                <button class="contact-eng">查看评价</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="remove" @click.stop.prevent="deleteOrder(item.detail[0].orderno,index)">删除</div>
                                </li>
                            </ul>
                        </Loadmore>
                    </div>
                </div>
            </div>
            
            <Footer_></Footer_>
        </div>
    </div>
</template>

<script>
import { Loadmore,MessageBox,Indicator,CellSwipe } from 'mint-ui';
import Footer_ from './Footer.vue';
import moment from 'moment'

export default {
    name:"orderList",
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            orders:[],
            allLoaded:false,
            page:1,
            startX: 0,       //触摸位置
            moveX: 0,       //滑动时的位置
            disX: 0,       //移动距离
            startX:0,   //触摸位置
            endX:0,     //结束位置
            moveX: 0,   //滑动时的位置
            disX: 0,    //移动距离
            deleteSlider: [],//滑动时的效果,使用v-bind:style="deleteSlider"
            touchIndex:"",
            norder:false,
            isPullingDown:false,
            isPullingUp:false,
            wrapperHeight:0,
            loginstatus: false,
            path: '',
            comment: {},
            modalStatus: false,
            sheetStatus: false,
            timer: {}
        }
    },
    methods:{
        closeSheet(){
            let vm = this
            setTimeout(function(){
                vm.modalStatus = false
            },500)
            this.sheetStatus = false
        },
        getCommentDetail(comment_id){
            let access_token = localStorage.access_token
            let info = {
                id: comment_id,
                access_token: access_token
            }
            this.$store.dispatch('getCommentDetail',info).then((res)=>{
                let result = res.data
                if(result.code == 0){
                    this.comment = result.res
                    this.modalStatus = true
                    let vm = this
                    setTimeout(function(){
                        vm.sheetStatus = true
                    },300)
                }
            })
        },
        goEvaluation(service){
            this.$router.push({name:"evaluation",query:{service_no:service.service_no,eng_no:service.eng_no}})
        },
        goMessages(){
            if(this.validToken('message','查看消息中心')){
                this.$router.push({name:"message"})
            }
        },
        goLogin(btn){
            this.$router.push({name:"login",query:{path:'orderList',entryButton: btn}})
        },
        goBack(){
            this.$router.push({name:"my"})
        },
        loadTop() {
            this.page = 1;
            this.orders = [];
            this.allLoaded = false;
            this.isPullingDown = true;
            this.getOrderList();
        },
        loadBottom() {
            this.page = this.page+1;
            this.isPullingUp = true;
            this.getOrderList();
            this.$refs.loadmore.onBottomLoaded();
        },
        gopay(orderno){
            this.$router.push({name:"pay",query:{
                'orderno':orderno
            }})
        },
        getOrderList(){
            var access_token = localStorage.access_token;
            var page = this.page;
            page = page ? page : 1;
            var info = {
                access_token:access_token,
                page:page,
                app_id :window.config.appid,    
                api_version : window.config.api_version,
            }
           
            let vm = this;
            this.$store.dispatch("getOrderList",info).then((res)=>{
                var data = res.data;
                if(data.code == 0){
                    vm.orders = vm.orders.concat(data.res.orders);
                    vm.norder = !vm.orders.length?true:false;
                    vm.deleteSlider = [];
                    for(let i=0;i<vm.orders.length;i++){
                        vm.deleteSlider.push( "transform:translateX(0px)");
                    }
                    if(vm.isPullingDown){
                        vm.$nextTick(function(){
                            vm.$refs.loadmore.onTopLoaded();
                            vm.isPullingDown = false;
                        })
                    }
                    if(vm.isPullingUp){
                         vm.$nextTick(function(){
                            vm.$refs.loadmore.onBottomLoaded();
                            vm.isPullingUp = false;
                        })
                    }
                    if(vm.orders.length == data.res.count){
                        vm.allLoaded = true;
                    }
                }
            })
        },
        cancelOrder(orderno){
           MessageBox.confirm('确定取消此订单?').then(action => {
                if(this.validToken()){
                let vm = this;
                let access_token = localStorage.access_token;
                let info = {
                    'access_token':access_token,
                    'orderno':orderno
                };
                this.$store.dispatch("cancelOrder",info).then((res)=>{
                    let data = res.data;
                    let code = data.code;
                    if(code == 0){
                        vm.loadTop();

                    }else if(code == 1200){
                        new Promise(vm.refreshToken).then(function(token){
                            info.access_token = token;
                            vm.$store.dispatch("cancelOrder",info).then((res)=>{
                                let data_ = res.data;
                                let code_  = res.data.code;
                                if(code_ == 0){
                                    vm.loadTop();
                                }else{
                                    vm.$router.push({name:"login"})
                                }

                            })
                        })
                       
                    }else if(code == 1201){
                        vm.$router.push({name:"login"})
                    }
                })
            }
            });
           
        },
        deleteOrder(orderno,index){
            MessageBox.confirm('确定删除此订单?').then(action => {
                if(this.validToken()){
                let vm = this;
                let access_token = localStorage.access_token;
                let info = {
                    'access_token':access_token,
                    'orderno':orderno,
                    'api_version':window.config.api_version
                };
                this.$store.dispatch("deleteOrder",info).then((res)=>{
                    let data = res.data;
                    let code = data.code;
                    if(code == 0){
                        vm.orders.splice(index,1);
                        if(vm.orders.length==0){
                            vm.loadTop()
                        }
                        vm.deleteSlider.splice(index,1);
                    }else if(code == 1200){
                        new Promise(vm.refreshToken).then(function(token){
                            info.access_token = token;
                            vm.$store.dispatch("deleteOrder",info).then((res)=>{
                                let data_ = res.data;
                                let code_  = res.code;
                                if(code_ == 0){
                                    vm.orders.splice(index,1);
                                    vm.deleteSlider.splice(index,1);
                                    
                                }else{
                                    vm.$router.push({name:"login"})
                                }
                            })
                        })
                    }else if(code == 1201){
                        vm.$router.push({name:"login"})
                    }
                })
            }
            });
        },
        goOrderDetail(status,orderno,allow_chat){
            this.$router.push({'name':"orderDetail",query:{'orderno':orderno,'allow_chat':allow_chat}})
        },
        touchStart(ev,index,data){
            if(data.status === '1' || (data.service && (data.service.status == '6' || data.service.status == '7'))){
                this.touchIndex = index;
                ev= ev || event
                //tounches类数组，等于1时表示此时有只有一只手指在触摸屏幕
                this.deleteSlider.splice(0,this.orders.length);
                for(let i=0;i<this.orders.length;i++){
                    this.deleteSlider.push( "transform:translateX(0px)");
                }
                if(ev.touches.length == 1){
                    // 记录开始位置
                    this.startX = ev.touches[0].clientX;
                }
            }
        },
        touchMove(ev,index){
            if(this.touchIndex === index){
                 ev = ev || event;
                //获取删除按钮的宽度，此宽度为滑块左滑的最大距离
                let wd=document.getElementsByClassName('remove')[0].offsetWidth;
                if(ev.touches.length == 1) {
                    // 滑动时距离浏览器左侧实时距离
                    this.moveX = ev.touches[0].clientX
                    //起始位置减去 实时的滑动的距离，得到手指实时偏移距离
                    this.disX = this.startX - this.moveX;
                    // 如果是向右滑动或者不滑动，不改变滑块的位置
                    if(this.disX < 0 || this.disX == 0) {
                    // this.deleteSlider = "transform:translateX(0px)";
                    // 大于0，表示左滑了，此时滑块开始滑动 
                }else if (this.disX > wd*0.7) {
                    //具体滑动距离我取的是 手指偏移距离*5。
                    this.deleteSlider.splice(this.touchIndex,1,"transform:translateX(-" + this.disX*5 + "px)")
                    // this.deleteSlider[this.touchIndex] = "transform:translateX(-" + this.disX*5 + "px)";
                    
                    // 最大也只能等于删除按钮宽度 
                    if (this.disX*2 >=wd) {
                            this.deleteSlider.splice(this.touchIndex,1,"transform:translateX(-" +wd+ "px)")
                    }
                    }
                }
            }
        },
        touchEnd(ev,index){
            if(this.touchIndex === index){
                 ev = ev || event;
                let wd=document.getElementsByClassName('remove')[0].offsetWidth;
                if (ev.changedTouches.length == 1) {
                    let endX = ev.changedTouches[0].clientX;
                    this.disX = this.startX - endX;
                    //如果距离小于删除按钮一半,强行回到起点
                    if ((this.disX*5) < (wd/2)) {
                        this.deleteSlider.splice(this.touchIndex,1,"transform:translateX(0px)")
                    }else{
                        //大于一半 滑动到最大值
                        this.deleteSlider.splice(this.touchIndex,1,"transform:translateX(-"+wd+ "px)")
                    }
                }
                this.touchIndex = ""
            }
        }      
    },
    created(){
        this.path = this.$route.query.path
        let access_token = localStorage.access_token
        this.loginstatus = access_token?true:false
        let expire_time = localStorage.expire_time
        let now = new moment().valueOf()
        let comment_id = this.$route.query.comment_id
        if(comment_id){
            this.getCommentDetail(comment_id)
        }
        if(this.loginstatus && expire_time > now){
            this.getOrderList();
        }else {
            this.loginstatus = false
        }
    },
    mounted(){
    },
    components:{
        Footer_,
        Loadmore,
        CellSwipe
    },
    filters:{
        serviceStatus(val){
            if(val == 0){
                return '工单已作废'
            }
            if(val == 1){
                return '工单已取消'
            }
            if(val == 2){
                return '未分配'
            }
            if(val == 3){
                return '派单成功'
            }
            if(val == 4){
                return '预约成功'
            }
            if(val == 5){
                return '服务中'
            }
            if(val == 6){
                return '服务完成'
            }
            if(val == 7){
                return '服务完成'
            }
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/OrderList.vue